import React from "react";
import SectionTitle from "./SectionTitle";
import GuestScrollReveal from "./GuestScrollReveal";
import LazyTeaserVideo from "./LazyTeaserVideo";
import { GUEST_SECTION_IDS } from "../../data/guestPageData";

const VideoSection = () => {
    return (
        <section
            className="guest-section guest-section--teaser"
            id={GUEST_SECTION_IDS.teaser}
        >
            <GuestScrollReveal>
                <SectionTitle>
                    <span className="guest-section-title__accent">
                        ОФИЦИАЛЬНЫЙ ТИЗЕР ПРОЕКТА
                    </span>
                </SectionTitle>
            </GuestScrollReveal>
            <GuestScrollReveal delay={0.08}>
                <div className="guest-section__content guest-teaser">
                    <LazyTeaserVideo />
                </div>
            </GuestScrollReveal>
        </section>
    );
};

export default VideoSection;
